exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".large-block {\n  width: 100%;\n  max-width: 950px;\n}\n\n.no-shadow {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n\n.project-tile {\n  -webkit-box-shadow: 2px 2px 10px #4e4e4e;\n          box-shadow: 2px 2px 10px #4e4e4e;\n  display: inline-block;\n  height: 300px;\n  margin: 15px 10px;\n  padding: 8px;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n  vertical-align: top;\n  width: 30.2%;\n}\n\n.project-tile:hover {\n  -webkit-box-shadow: 2px 2px 20px #4e4e4e;\n          box-shadow: 2px 2px 20px #4e4e4e;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n\n.project-tile-image img {\n  width: 100%;\n}\n\n.project-tile-caption p {\n  font-size: 14px;\n}\n\n/* responsive styles */\n\n@media screen and (max-width: 810px) {\n  .project-tile {\n    display: block;\n    height: auto;\n    width: 70%;\n    margin: 0 auto 60px auto;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .project-tile {\n    width: 95%;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/abeltrotter/Documents/git/epicodus/javascript/portfolio-angular/src/app/projects/projects.component.css
// module id = ../../../../../src/app/projects/projects.component.css
// module chunks = main